import {  useState } from 'react';
import TimekeepingTable from './TimeKeepingTable';
import TimeTracker from './TimeTracker';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import { showSidePanel } from '../../store/actions/sidePanelActions';
import apis from '../../utils/apis';
import { showFeedbackModal } from '../../store/actions/UserFeedbackActions';


const Timekeeping = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const [viewType, setViewType] = useState<'ongoing' | 'active'>('ongoing');


const handleRowClick = async (entryId: number) => {
  try {
    const resp: any = await apis({
      method: 'POST',
      url: '/timekeeping/get_time_entry_details',
      headers: {
        'Content-Type': 'application/json' 
      },
      data: { entry_id: entryId } 
    });
    if (resp && resp.status === 200) {
      dispatch(showSidePanel({
        type: 'timeEntryDetails',
        showSidePanel: true,
        width: '50%',
        onConfirm: () => {},
        onCancel: () => {},
        data: resp.data.time_entry,
      }));
    } else {
      dispatch(showFeedbackModal({
        modalType: 'error',
        message: resp.data?.message || t('An unexpected error occurred'),
        duration: 3000,
        showModal: true
      }));
    }
  } catch (err) {
    dispatch(showFeedbackModal({
      modalType: 'error',
      message: t('Failed to receive response'),
      duration: 3000,
      showModal: true
    }));
  }
};


  return (
    <div className="px-2 flex flex-col space-y-4">
      <div className="flex flex-row justify-between space-x-2">
        <div className='flex-1 flex'>
          <TimeTracker />
        </div>
      </div>

      <TimekeepingTable
          type={viewType}
          setViewType={setViewType}
          onRowClick={handleRowClick}
          filters={[]} 
          sortOptions={[]} 
          selectedFilters={{}}
          onFilterChange={() => {}}
          onSortChange={() => {}}
          onSearchChange={() => {}}
          sortValue=""
        />

    </div>
  );
};

export default Timekeeping;
